import styledTheme from "common/theme";
import styled from "styled-components";


export const LoadingContainer = styled.div`
    display: block;
    font-size: 18px;
    width: 30px;
    height: 20px;

    &:after {
        overflow: hidden;
        display: inline-block;
        vertical-align: bottom;
        width: 0px;
        content: '...';
        animation: ellipsis steps(4,end) 900ms infinite;
    }

    @keyframes ellipsis {
        to {
            width: 1.25em;    
        }
    }
`


export const MachineStatusContainer = styled.div<{ color?: string }>`
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    font-size: clamp(13px, 1.4vw, 17px);

    svg {
        width: 12px;
        height: 12px;
    }

    img {
        width: 18px;
        height: 18px;
        margin: 3px;
    }

    .label {
         color: ${({ color }) => color || 'inherit'};
         font-weight: 600;
         font-size: 1rem;
    }

    .timestamp {
        color: ${styledTheme.colors.muted};
        padding: 0 0.5rem;
    }
`